import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addComment, editComment } from "state/slices/comment";
import _get from "lodash/get";
import { Formik, Field } from "formik";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";

import FormFieldsCard from "components/lib/Global/FormFieldsCard";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import CommentsList from "components/lib/Global/CommentsList";
import Accordion from "components/lib/Global/Accordion";
import SummaryOfArticlesReview, {
  summaryOfArticlesFieldsName,
} from "components/lib/Global/SummaryOfArticlesReview";
import { Constants } from "config/constants";
import { InformationCircleIcon } from "@heroicons/react/solid";

function GovernanceSummary({ isViewMode }) {
  const { company } = useSelector((state) => state.companySlice);
  const {
    companyFormation: { step2, resolvedFields },
  } = useSelector((state) => state.companySlice);
  const { comments } = useSelector((state) => state.commentsSlice);

  const dispatch = useDispatch();

  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { transactions } = transactionUnderReview.items;

  const changeOfArticlesTransaction = transactions.find(
    (trx) =>
      trx.changeType === Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_ARTICLES
  );
  const changeOfArticlesIndex = transactions.findIndex(
    (trx) => trx._id === changeOfArticlesTransaction?._id
  );

  const updateEffectKey = "updateTransactionUnderReview";
  const formHelperKey = "initiateTransactionChange";

  const buildUpdateEffectPath = (sliceIndex) =>
    `transactionSlice.transactionUnderReview.items.transactions.${sliceIndex}`;
  const changeOfArticlesUpdateEffectPath = buildUpdateEffectPath(
    changeOfArticlesIndex
  );
  const changeOfArticlesComments = comments.filter(
    (comment) =>
      comment.transaction === changeOfArticlesTransaction?._id &&
      comment.formName === "changeOfArticles"
  );

  const articlesType = _get(step2, "articlesOfAssociation.articlesType");
  let articlesOfAssociationToUse = _get(step2, "articlesOfAssociationToUse");

  if (articlesOfAssociationToUse) {
    if (articlesOfAssociationToUse === "ModifiedArticlesOfAssociation")
      articlesOfAssociationToUse = "Modified articles of association";
    else articlesOfAssociationToUse = "Own articles of association";
  }
  const companyArticlesOfAssociation = _get(
    step2,
    "articlesOfAssociation.template",
    {}
  );
  const transactionArticlesOfAssociation =
    changeOfArticlesTransaction?.articlesTemplate;
  const articlesOfAssociation = transactionArticlesOfAssociation;

  let companyLatestTemplate = {};
  let latestTemplateVersion = {};
  if (articlesOfAssociation?.versions?.length > 0) {
    latestTemplateVersion =
      articlesOfAssociation.versions[
        articlesOfAssociation?.versions?.length - 1
      ];
  }
  if (companyArticlesOfAssociation?.versions?.length > 0) {
    companyLatestTemplate =
      companyArticlesOfAssociation.versions[
        companyArticlesOfAssociation?.versions?.length - 1
      ];
  }
  const summaryOfArticles = latestTemplateVersion?.summary ?? {};
  const companySummary = companyLatestTemplate?.summary ?? {};

  const handleSaveComment = async (data) => {
    if (data?.commentId) {
      dispatch(editComment({ commentId: data.commentId, data }));
    } else {
      dispatch(
        addComment({
          data: {
            ...data,
            company: company._id,
            transaction: changeOfArticlesTransaction?._id,
          },
        })
      );
    }
  };

  const articlesOfAssociationFields = [
    {
      key: "Articles of association",
      name: "articlesOfAssociationToUse",
      value: articlesOfAssociationToUse || "N/A",
      editorParams: {
        companyId: company._id,
        url: latestTemplateVersion?.fileUploads?.template
          ? `${process.env.REACT_APP_IMAGE_BASE_URL}/templates/${latestTemplateVersion.fileUploads.template}`
          : null,
        editorKey: `${articlesOfAssociation._id}-${latestTemplateVersion?._id}`,
        mode: !isViewMode,
        permissions: {
          edit: !isViewMode,
          review: true,
        },
        containerHeight: "900px",
      },
      SummaryOfArticles: () => (
        <div className="border border-gray-300 overflow-auto max-h-full">
          {changeOfArticlesComments.length > 0 && (
            <div className="px-8 pt-5 pb-6 bg-white">
              <CommentsList
                comments={changeOfArticlesComments}
                toggleCommentStatus={!isViewMode}
              />
              <p className="mt-6 text-sm text-primary">
                Comments: {changeOfArticlesComments.length} of{" "}
                {changeOfArticlesComments.length}
              </p>
            </div>
          )}
          <SummaryOfArticlesReview
            summary={summaryOfArticles}
            templateType={articlesOfAssociation.templateType}
            entityType={articlesOfAssociation.entityType}
            formName={"changeOfArticles"}
            addReviewComment={!isViewMode}
            resolvedFields={resolvedFields}
            formHelperKey={formHelperKey}
            updateEffectKey={updateEffectKey}
            formId={_get(changeOfArticlesTransaction, "_id")}
            handleSaveComment={handleSaveComment}
            comments={changeOfArticlesComments}
            hideResolveAllCheckbox={isViewMode}
            isViewMode={isViewMode}
            wrapperStyles="mt-0"
            renderReviewIcon={false}
            renderAcceptIcon={false}
          />
        </div>
      ),
    },
    {
      key: "Summary of articles",
      value: (
        <Accordion
          titleClasses="font-medium text-primary text-sm"
          wrapperClasses=""
          tabs={[
            {
              title: "Summary of articles",
              commentsCount: comments.filter(
                (comment) =>
                  comment.formName?.includes(`articlesOfAssociation`) &&
                  summaryOfArticlesFieldsName.includes(comment.fieldName)
              ).length,
              content: (
                <SummaryOfArticlesReview
                  summary={summaryOfArticles}
                  companySummary={companySummary}
                  templateType={articlesOfAssociation.templateType}
                  entityType={articlesOfAssociation.entityType}
                  formName={"changeOfArticles"}
                  addReviewComment={!isViewMode}
                  resolvedFields={resolvedFields}
                  formHelperKey={formHelperKey}
                  updateEffectKey={updateEffectKey}
                  formId={_get(changeOfArticlesTransaction, "_id")}
                  handleSaveComment={handleSaveComment}
                  comments={changeOfArticlesComments}
                  hideResolveAllCheckbox={isViewMode}
                  isViewMode={isViewMode}
                />
              ),
            },
          ]}
        />
      ),
      onlyRenderValue: true,
    },
    {
      key: "Other objects for which company is established",
      name: "articlesType",
      value: articlesType || "N/A",
    },
  ];

  if (articlesType === "Regulated") {
    articlesOfAssociationFields.push(
      {
        key: "Name of regulator",
        name: "nameOfRegulator",
        value: _get(step2, "articlesOfAssociation.nameOfRegulator", "N/A"),
      },
      {
        key: "Regulator institute",
        name: "regulatorInstitute",
        value: _get(step2, "articlesOfAssociation.regulatorInstitute", "N/A"),
      },
      {
        key: "No objection letter",
        name: "regulatedArticles_LNO",
        value: (
          <>
            <Formik
              enableReinitialize
              initialValues={{
                fileUploads: {
                  regulatedArticles_LNO: _get(
                    step2,
                    "fileUploads.regulatedArticles_LNO"
                  ),
                },
              }}
              onSubmit={() => null}
            >
              {() => {
                return (
                  <div className="w-full p-2 text-sm rounded-md bg-formInput text-primary placeholder-primary focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300">
                    {_get(step2, "fileUploads.regulatedArticles_LNO") ? (
                      <Field
                        name="fileUploads"
                        component={FileUploadForm}
                        documentData={[
                          {
                            name: `regulatedArticles_LNO`,
                            label: `regulatedArticles_LNO`,
                          },
                        ]}
                        onlyPreview
                        formName={`articlesOfAssociation`}
                        handleSaveComment={handleSaveComment}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                );
              }}
            </Formik>
          </>
        ),
      }
    );
  } else {
    articlesOfAssociationFields.push({
      key: "Nature of business",
      name: "natureOfBusiness",
      value: _get(step2, "articlesOfAssociation.natureOfBusiness", "N/A"),
    });
  }

  return (
    <>
      {changeOfArticlesComments.length > 0 && (
        <div className="px-8 pt-5 pb-6 bg-white">
          <CommentsList
            comments={changeOfArticlesComments}
            toggleCommentStatus={!isViewMode}
          />
          <p className="mt-6 text-sm text-primary">
            Comments: {changeOfArticlesComments.length} of{" "}
            {changeOfArticlesComments.length}
          </p>
        </div>
      )}
      {
        <div className="rounded-md bg-light-blue/10 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <InformationCircleIcon
                className="h-5 w-5 text-light-blue"
                aria-hidden="true"
              />
            </div>
            <div className="ml-3 flex-1 md:flex md:justify-between">
              <p className="font-medium text-sm text-light-blue">
                Please ensure you complete the Company Number in the Articles of
                Association below.
              </p>
            </div>
          </div>
        </div>
      }
      <FormFieldsCard
        addReviewComment={!isViewMode}
        formName="changeOfArticles"
        fields={articlesOfAssociationFields}
        resolvedFields={resolvedFields}
        formHelperKey={formHelperKey}
        updateEffectKey={updateEffectKey}
        updateEffectPath={changeOfArticlesUpdateEffectPath}
        formId={_get(changeOfArticlesTransaction, "_id")}
        handleSaveComment={handleSaveComment}
        comments={changeOfArticlesComments}
        hideResolveAllCheckbox={isViewMode}
        isViewMode={isViewMode}
      />
    </>
  );
}

export default GovernanceSummary;
